import {Component, inject, OnInit} from '@angular/core';
import {Router, RouterModule} from '@angular/router';
import {CommonModule} from "@angular/common";
import {SharedCommonModule} from "./shared/commons/shared-common.module";
import {SecurityService} from "./security/security.service";
import {UserDataService} from "./security/user-data.service";

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    SharedCommonModule
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  title = 'SRM Process';
  public router: Router = inject(Router);
  public authenService: SecurityService = inject(SecurityService);
  public userDataService: UserDataService = inject(UserDataService);

  ngOnInit(): void {
    this.authenService.checkAuth()
      .subscribe(loginResponse => {
        // console.log('AppComponent LoginResponse : ', loginResponse);
        if (loginResponse.isAuthenticated) {
          this.userDataService.getCurrent()
            .subscribe(user => {
              // console.log('user data ', user);
            });
        }
      });
  }
}
